import React from 'react';
import { HTMLAttributes } from 'react';
import styled, { css } from 'styled-components';

import JustificationContainer from '../JustificationContainer';

export type Props = {
  dataTestId?: string;
  src: string;
  alt?: string;

  /** Restrict the image within the container to max width, px value */
  maxWidth?: number;
  withoutShadow?: boolean;
} & HTMLAttributes<HTMLImageElement>;

const Screenshot: React.FC<Props> = ({
  dataTestId,
  src,
  alt = 'Screenshot',
  maxWidth,
  withoutShadow = false,
  ...rest
}) => (
  <JustificationContainer
    justification="center"
    align="center"
    dataTestId={dataTestId}
  >
    <Img
      src={src}
      alt={alt}
      $maxWidth={maxWidth}
      $withoutShadow={withoutShadow}
      {...rest}
    />
  </JustificationContainer>
);

const Img = styled.img<{
  $maxWidth?: number;
  $withoutShadow: boolean;
}>(
  ({ theme, $maxWidth, $withoutShadow }) => css`
    width: 100%;
    border-radius: ${theme.getTokens().border.radius.base};
    box-shadow: ${$withoutShadow
      ? 'unset'
      : theme.getTokens().boxShadow.around};
    max-width: ${$maxWidth ? `${$maxWidth}px` : 'auto'};

    &:before {
      display: block;
      content: '';
      width: 100%;
      padding-top: calc(calc(9 / 16) * 100%);
    }
  `,
);

export default Screenshot;
